// Statični podaci za stranicu O aplikaciji (Postavke). Verzija dolazi s backenda (GET /api/v1/app-info),
// vrijeme builda iz Vite define (__APP_BUILD_TIME__), okruženje iz VITE_APP_ENV.

export const APP_NAME = 'CXM';
export const APP_TAGLINE = 'Contract Execution Management';

// Izvor: byteink.hr (kontakt); OIB potvrdio korisnik. Adresa i e-mail usklađeni s prezentacijom
// i QR kontaktom (Radnička cesta 57, sales@byteink.hr) — 23.10.2026.
export const MANUFACTURER = {
  name: 'Byteink d.o.o.',
  taxId: '90619433953',
  address: 'Radnička cesta 57, 10000 Zagreb',
  website: 'www.byteink.hr',
  supportEmail: 'sales@byteink.hr'
};

// Poveznice se prikazuju tek kad imaju adresu — dok dokumenti ne postoje, red s poveznicama je skriven.
export const LEGAL_LINKS: { labelKey: string; url: string }[] = [
  { labelKey: 'about.terms', url: '' },
  { labelKey: 'about.privacy', url: '' },
  { labelKey: 'about.licenses', url: '' }
].filter((link) => link.url);
